import { ChevronRight } from 'react-feather';

import i18nService from '../../../services/i18nService';

export default function ConfigurationSummary(props) {
  const watch = props.selectedColor.variantId
  const strap = props.selectedStrap.variantId
  const kit = props.selectedCase.variantId
  const checkoutUrl = `https://milus.com/cart/${watch}:1,${strap}:1,${kit}:1?discount=PERSONALMILUS`

  let watchImage;
  if (props.selectedColor.strapOptions) {
    watchImage = props.selectedColor.strapOptions[props.selectedStrap.id]
  } else {
    watchImage = props.selectedColor.production_cover
  }

  return (
    <div className="ConfigurationSummary">
      <div className="ConfigurationSummary-grid">
        <div className="Carousel-slide" onClick={() => props.setStep(2)}>
          <div
            className="Carousel-slide-image"
            style={{ backgroundImage: `url(${watchImage})`}}
            />
          <div className="Carousel-slide-text">
            <h2 className="Carousel-slide-title">
              <span className="Carousel-slide-title-pre">{props.selectedColor.name_pre}</span> {props.selectedColor.name} <span className="Carousel-slide-title-post">{props.selectedColor.name_post}</span>
            </h2>
            <p className="Carousel-slide-price"><small>{i18nService.translate(props.locale, 'worth')}</small> {props.selectedColor.price_from}</p>
          </div>
        </div>

        <div className="Carousel-slide" onClick={() => props.setStep(3)}>
          <div
            className="Carousel-slide-image"
            style={{ backgroundImage: `url(${props.selectedStrap.production_cover})`}}
            />
          <div className="Carousel-slide-text">
            <h2 className="Carousel-slide-title">
              <span className="Carousel-slide-title-pre">{props.selectedStrap.name_pre}</span> {props.selectedStrap.name} <span className="Carousel-slide-title-post">{props.selectedStrap.name_post}</span>
            </h2>
            <div className="Carousel-slide-price-container">
              <p className="Carousel-slide-price strike-through"><small>{i18nService.translate(props.locale, 'worth')}</small> {props.selectedStrap.price_from}</p>
              <p className="Carousel-slide-price-notice"><small>{i18nService.translate(props.locale, 'included')}</small></p>
            </div>
          </div>
        </div>

        <div className="Carousel-slide" onClick={() => props.setStep(4)}>
          <div
            className="Carousel-slide-image"
            style={{ backgroundImage: `url(${props.selectedCase.production_cover})`}}
            />
          <div className="Carousel-slide-text">
            <h2 className="Carousel-slide-title">
              <span className="Carousel-slide-title-pre">{props.selectedCase.name_pre}</span> {props.selectedCase.name} <span className="Carousel-slide-title-post">{props.selectedCase.name_post}</span>
            </h2>
            <div className="Carousel-slide-price-container">
              <p className="Carousel-slide-price strike-through"><small>{i18nService.translate(props.locale, 'worth')}</small> {props.selectedCase.price_from}</p>
              <p className="Carousel-slide-price-notice"><small>{i18nService.translate(props.locale, 'included')}</small></p>
            </div>
          </div>
        </div>
      </div>

      <a className="proceed-to-checkout desktop-only" href={checkoutUrl}>
        {i18nService.i18n(props.locale, 'checkout.ordernow')} <ChevronRight size={15} />
      </a>
    </div>
  )
}
